import { ArrowLeftOutlined } from '@ant-design/icons'
import { Button, PageHeader, Space } from 'antd'
import React from 'react'
import { useTranslation } from 'react-i18next'
import { useNavigate } from 'react-router-dom'

type Props = {
  washingMachineId: number
}

const UpdateMachinePartPageHeader = ({ washingMachineId }: Props) => {
  const { t } = useTranslation()
  const navigate = useNavigate()

  return (
    <Space>
      <Button onClick={() => navigate(`/machines/${washingMachineId}/machine-part`)} icon={<ArrowLeftOutlined />} />
      <PageHeader ghost={false} title={t('components.pages.machineParts.update.pageHeader.title')} />
    </Space>
  )
}

UpdateMachinePartPageHeader.displayName = 'UpdateMachinePartPageHeader'
export default UpdateMachinePartPageHeader
